window.addEventListener('scroll', function(){
  if( window.scrollY > 3 ) {
    document.querySelector(".shopify-section--header").classList.add('scrolled');
    document.querySelector("body").classList.add('scrolled');
  } else {
    document.querySelector(".shopify-section--header").classList.remove('scrolled');
    document.querySelector("body").classList.remove('scrolled');
  }
});



/*
const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
     document.querySelector(".landing").classList.add('scrollEnd');
    } else {
      document.querySelector(".landing").classList.remove('scrollEnd');
    }
  });
});
// 監視対象の要素を選択
const targetElement = document.querySelector("#Footer");
observer.observe(targetElement);
*/


/*
window.addEventListener( "scroll", function() {
     let header = document.querySelector(".shopify-section--header");
     let rect = header.getBoundingClientRect();
     let y = rect.top + window.pageYOffset;
     if (y > 50) {
         header.classList.add('scrolled');
     } else {
         header.classList.remove('scrolled');
     }
});
*/


/*
const topSwiper = new Swiper('.heroSwiper', {
    // Optional parameters
    loop: true,
    speed: 3000,
    effect: "fade",
    fadeEffect: {
    crossFade: true},
    autoplay: {
        delay: 3500,
    },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },
});


const cocktailWrapper = new Swiper('#cocktail .wrapper', {
    // Optional parameters
    loop: true,
    slidesPerView: 1.5,
    spaceBetween: 40,
    centeredSlides: true,
    clickable: true,
    grabCursor: true,
    //spaceBetween: auto,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
  breakpoints: {
    // when window width is >= 640px
    350: {
      slidesPerView: 1.4,
    },
    640: {
      slidesPerView: 2,
    },
    1280: {
      slidesPerView: 3,    
      loop: false,
      centeredSlides: false,
      },
    }
});


const newWrapper = new Swiper('#new .wrapper', {
    loop: true,
    //initialSlide: 2;
    slidesPerView: 1.4,
    spaceBetween: 40,
    centeredSlides: true,
    clickable: true,
    grabCursor: true,
    breakpoints: {
    // when window width is >= 640px
    350: {
      slidesPerView: 1.4,
    },
    640: {
      slidesPerView: 2,
    },
    1280: {
      slidesPerView: 3,    
      loop: false,
      centeredSlides: false,
      },
    }
});




const productSwiper = new Swiper('.product-swiper', {
    // Optional parameters
    loop: true,
    speed: 3000,
    effect: "fade",
    fadeEffect: {
    crossFade: true},
    autoplay: {
        delay: 3500,
    },
  pagination: {
        el: '.swiper-pagination',
    },
    on: {
        init: function () {
            setTimeout(() => {
                const pagiNation = document.querySelector('.swiper-pagination');
                pagiNation.classList.add('is-active');
            }, 50);
        },
        slideChangeTransitionStart: function () {
            const border = document.querySelector('.js-border span');
            if (border) {
                border.style.transform = 'scaleX(0)';
                border.style.transitionDuration = '0s';
            }
        },
        slideChangeTransitionEnd: function () {
            const border = document.querySelector('.js-border span');
            if (border) {
                border.style.transform = 'scaleX(1)';
                border.style.transitionDuration = '3500ms';
            }
        },
    },
});






const bannerSwiper = new Swiper('.banner-swiper', {
    // Optional parameters
    loop: true,
    speed: 2500,
    effect: 'fade',
    autoplay: {
        delay: 4000,
    }
});


*/
const opener = document.querySelector('.menu-btn');
opener.addEventListener("click", function() {
  document.querySelector('#header').classList.toggle('is-active');
  //document.querySelector('html').classList.add('lock');
  document.querySelector(".shopify-section--header").classList.add('scrolled');
});
const closer = document.querySelector('.close-button');
closer.addEventListener("click", function() {
  document.querySelector('#header').classList.remove('is-active');
  //document.querySelector('html').classList.remove('lock');
});

/*
document.querySelector('.menu-btn').addEventListener('click', function(){
    document.querySelector('#header').classList.toggle('is-active');
    document.querySelector('html').classList.toggle('is-active');
});
*/















document.addEventListener('DOMContentLoaded', () => {
  // Select all Buy Buttons
  const buyButtons = document.querySelectorAll('.jds-cart-button:not([data-anygift="add-to-cart"])');

  // Add click event listener to each button
  buyButtons.forEach((button) => {
    button.addEventListener('click', async (event) => {
      event.preventDefault();

      // Get the variant ID from the button's data attribute
      const variantId = button.getAttribute('data-variant-id');
      if (!variantId) {
        console.error('Variant ID not found!');
        return;
      }

      try {
        const addBody = { id: variantId, quantity: 1 };

        // Send AJAX request to add product to the cart
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(addBody),
        });

        if (!response.ok) {
          throw new Error('Failed to add product to cart');
        }

        // Parse the response JSON
        const cartData = await response.json();

        // のしが選択されていれば同時に追加
        const noshiCheckbox = document.getElementById('noshi-checkbox');
        if (noshiCheckbox && noshiCheckbox.checked) {
          const noshiVariantId = parseInt(noshiCheckbox.dataset.noshiVariant);
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: noshiVariantId, quantity: 1 }),
          });
          const purposeEl = document.getElementById('noshi-purpose-p');
          const omoteEl = document.getElementById('noshi-omote-p');
          const nameEl = document.getElementById('noshi-name-p');
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              attributes: {
                noshi_purpose: purposeEl ? purposeEl.value : '',
                noshi_omote: omoteEl ? omoteEl.value : '',
                noshi_name: nameEl ? nameEl.value : '',
              },
            }),
          });
        }

        // Redirect to cart page
        window.location.href = '/cart';

      } catch (error) {
        console.error('Error adding to cart:', error);
        alert('There was an issue adding the product to your cart.');
      }
    });
  });
});

// Fetch the latest cart data (helper function)
async function fetchCartData() {
  const response = await fetch('/cart.js');
  if (!response.ok) {
    throw new Error('Failed to fetch cart data');
  }
  return await response.json();
}


console.log(document.querySelector('cart-drawer'));



